module.exports = __webpack_public_path__ + "static/media/gel-top.19eb01fc.svg";